import { Box, useTheme } from '@mui/material';
import Divider from 'components/divider';
import React from 'react';
import RecommendationActions from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/components/recommendations/recommendation-actions';
import RecommendationCardInfo from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/components/recommendations/recommendation-card-info';
import RecommendationProductsList from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/components/recommendations/recommendation-products-list';
import { Recommendation } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/types/recommendation-assortment.type';

type Props = {
  recommendation: Recommendation;
};

// Chile (M3) forecasts have no vessel or loading plant, so the order details panel is left out.
const ChileRecommendationRowBody: React.FC<Props> = ({ recommendation }) => {
  const theme = useTheme();

  return (
    <Box paddingBottom={4} display={'flex'} flexDirection={'column'} gap={4}>
      <Box
        display={'flex'}
        sx={{
          border: `1px solid ${theme.palette.darkBlue.o25}`,
          borderRadius: 1,
        }}
        padding={2}
        marginBottom={2}>
        <RecommendationProductsList recommendation={recommendation} />
      </Box>

      <RecommendationCardInfo recommendation={recommendation} />
      <Divider
        sx={{
          m: theme.spacing(2, 0, 4, 0),
          borderColor: theme.palette.darkBlue.o25,
          width: '100%',
        }}
      />
      <RecommendationActions recommendation={recommendation} />
    </Box>
  );
};

export default React.memo(ChileRecommendationRowBody);
